import { defaultMessages } from "src/__generated__/messages";

export type MessageKey = keyof typeof defaultMessages;

export const isMessageKey = (key: string): key is MessageKey =>
	Object.keys(defaultMessages).includes(key);

// 🔬 TBD: Please evaluate
